import $ from "jquery";
import { compile } from "@bd-utils/handlerbars-helper";
import copyTextToClipboard from "@bd-utils/copyTextToClipboard";
import fb from "@bd-core/firebase";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import { getState, subscribe } from "@bd-stores/store";
import { getPlayers, getUserFromId } from "@bd-stores/game-progress";

export const WaitingRoom = () => {
  const isWaitingRoom = $("#page-waitingroom").length > 0;

  if (!isWaitingRoom) return false;

  const elms = {
    pageWaitingRoom: "#page-waitingroom",
    waitingroom: ".waitingroom",
    waitingroomSubtitle: ".waitingroom__subtitle",
    everyoneReadyTitle: ".js-ready-title",
    everyoneReadySubtitle: ".js-ready-subtitle",
    waitingEveryone: ".js-waiting-title",
    waitingEveryoneSubtitle: ".js-waiting-subtitle",
    readyBtn: ".js-ready-btn",
    cancelBtn: ".js-cancel-btn",
    messageboxForm: ".js-messagebox-form",
    messageboxName: ".js-messagebox-name",
    messageboxAvatar: ".js-messagebox-avatar",
    messageboxMsg: ".js-messagebox-message",
    messageboxSubmit: ".js-messagebox-submit",
    member: ".member",
    memberEmailValue: ".member-email span",
    startBtn: ".js-start-game",
    countdownSecond: ".waitingroom-countdown-timer .second .column.animate",
    countdownSecondNum:
      ".waitingroom-countdown-timer .second .column.animate .num",

    playerList: ".js-player-list",
    playerItem: ".js-player-item",
    deletePlayerBtn: ".js-player-item-delete",
    teamName: ".js-team-name",
    gameInfoLeave: ".js-leave-team",

    teamId: ".teamId",
    teamIdCopy: ".js-copy-team-id",
    teamIdValue: ".js-team-id-value",

    gameInfo: ".gameInfo",
    gameInfoBtn: ".gameInfo__btn",

    leaderPopup: ".js-leader-popup",

    // setup profile elements
    profileWrapper: ".profileBox",
    avatarWrapper: ".setAvatar",
    avatarImg: ".js-avatar",
    inputNameWrapper: ".setName",
    inputNickname: ".js-nickname",
    displayName: ".profileDisplay__name",
    displayAvatar: ".profileDisplay__avatar",
    avatarUpload: ".js-avatar-upload",
    uploadPreview: ".js-upload-preview",
    avatarUploadFilename: ".js-filename-avatar",
    submitProfile: ".js-save-profile",
    editProfileBtn: ".js-edit-profile",

    aspirationWall: ".js-aspiration-wall",
    aspirationPerson: ".aspiration__person",
  };

  /**
   * Get relative path of a url without the site / hostname
   *
   * @param {string} url
   */
  const getRelativeUrl = (url) => {
    const site = CONFIG.siteURL;
    return url.replace(site, "");
  };

  /**
   * Check is given url provided from avatar options or is it custom upload.
   * false mean it's provided avatar, true means it's custom upload
   *
   * @param {string} url file url to check
   */
  const checkIsCustomAvatar = (url) => {
    const options = CONFIG.game_options.avatar_options;

    if (options.length < 1) return false;

    const getUrl = (k) => getRelativeUrl(options[k]);
    const provided = Object.keys(options).map((k) => getUrl(k));
    return !provided.includes(url);
  };

  const getIsCompleteProfile = () => {
    const user = getUserFromId(CONFIG.user.id);
    const isFilledName = $(elms.inputNickname).val() !== "";
    // const isSelectedAvatar = CONFIG.user.avatar?.length > 0;

    const players = getPlayers();
    const myData = players.find((p) => p.userId === user?.userId);
    const hasSetupProfile = Boolean(myData?.hasSetupProfile);
    const isCompleteProfile = isFilledName && hasSetupProfile;

    return isCompleteProfile;
  };

  const render = (rawData = {}) => {
    const user = getUserFromId(CONFIG.user.id);
    const isUploadAvatar = checkIsCustomAvatar(user.avatarURL);
    const isCompleteProfile = getIsCompleteProfile();

    const avatarOptions = Object.keys(CONFIG.game_options.avatar_options).map(
      (k) => ({
        value: k,
        url: CONFIG.game_options.avatar_options[k],
        isSelected:
          isCompleteProfile && isUploadAvatar
            ? false
            : getRelativeUrl(CONFIG.game_options.avatar_options[k]) ===
              user.avatarURL,
      }),
    );

    const data = {
      ...rawData,
      teamCode: CONFIG.firebase.team_code.toUpperCase(),
      isUploadAvatar,
      avatarOptions,
      user: getUserFromId(CONFIG.user.id),
    };

    const template = $("#page-waitingroom-template").html();
    const html = compile(template, data);
    $("#page-waitingroom").html(html);
  };

  const renderAfterInitialized = () => {
    let hasRendered = false;

    subscribe(() => {
      const store = getState();
      if (!store.userProgress.isFirebaseInitialized) return;
      if (store.gameProgress.players.length < 1) return;
      if (hasRendered) return;
      hasRendered = true;
      render(getState().pageWaitingRoom);
    });
  };

  renderAfterInitialized();

  const updateUI = () => {
    const isCompleteProfile = getIsCompleteProfile();
    $(elms.profileWrapper).toggleClass("is-profile-set", isCompleteProfile);
    $(elms.pageWaitingRoom).toggleClass("is-profile-set", isCompleteProfile);
    $(elms.messageboxMsg).prop("disabled", !isCompleteProfile);
  };

  subscribe(() => {
    updateUI();
  });

  //----------------------------------------------------------------------- Initialize Firebase
  let alreadyStarted = false;

  const autoStartGame = async () => {
    if (alreadyStarted) return;
    alreadyStarted = true;

    bdjs.showLoading();
    await bdjs.goAsync(bdapi.post("game/start-game"));
    document.location.href = CONFIG.siteURL;
  };

  try {
    fb.initializeGame().then(() => {
      fb.update(fb.currentPlayerPath, { ready: true });
    });
  } catch (e) {
    console.error(e);
  }

  //----------------------------------------------------------------------- End Initialize Firebase

  // ------------------------------------------------------------------- WAITING ROOM

  let isLoading = false;
  let isReady = true;
  $("#page-waitingroom").addClass("is-ready");
  $(elms.readyBtn).hide();
  $(elms.cancelBtn).hide();
  $(elms.startBtn).hide();
  $(".countdown").hide();
  const onPlayerStateChange = (e, eData) => {
    if (!eData || !eData.data) return;

    //handle ready state
    isReady = eData.data.ready;
    $("#page-waitingroom").toggleClass("is-ready", isReady);
    const newText = isReady ? "I am ready" : "Ready?";

    $(elms.readyBtn).find(".ready-text").text(newText);
    $(elms.readyBtn).toggleClass("is-ready", isReady);
  };

  bdjs.listen("bd__playerStateChanged", onPlayerStateChange);

  //On players changed
  //-------------------------------------------------------------------------
  let isLeaving = false;
  let kickedPopup = false;
  const updatePlayersOrKickMe = (players) => {
    const htmlTemplate = $("#tpl-user-item").html();

    const htmlPlayers = players.reduce((result, rawPlayer) => {
      const { siteURL, user_progress, user } = CONFIG;
      const player = {
        ...rawPlayer,
        avatarURL: `${siteURL}${rawPlayer.avatarURL}`,
        is_leader: user_progress.is_leader && user.id == rawPlayer.userId,
        isOffline: !rawPlayer.isOnline,
        isMe: rawPlayer.userId === user.id,
      };

      return rawPlayer.userId
        ? `${result}${compile(htmlTemplate, player)}`
        : result;
    }, "");

    $(elms.playerList).html(htmlPlayers);

    //check for kicked players
    const isCurrentPlayerExist =
      players.filter((p) => p.userId === CONFIG.user.id).length > 0
        ? true
        : false;

    const $snackbar = $(".snackbar");
    if (!isCurrentPlayerExist && !isLeaving && !kickedPopup) {
      kickedPopup = true;
      $snackbar.find(".js-snackbar-body").html(CONFIG.strings.removedFromTeam);
      $snackbar.addClass("is-active");

      setTimeout(function () {
        window.location.reload();
      }, 3000);
      return false;
    }
  };

  const maybeReadyToStart = (players) => {
    let allReady = false;
    if (Array.isArray(players)) {
      let validPlayers = 0;
      let readyPlayers = 0;

      players.forEach((player) => {
        if (player.ready) readyPlayers++;
        if (player.userId) validPlayers++;
      });

      if (players.length >= 1) {
        allReady = readyPlayers >= 1 && readyPlayers == validPlayers;
      }

      // if (CONFIG.game.game_prop.singlePlayer && readyPlayers > 0) {
      //     allReady = true;
      // }
    }

    $(elms.waitingroomSubtitle).toggleClass("hide", allReady);

    if (allReady) {
      $(elms.everyoneReadyTitle).show();
      $(elms.everyoneReadySubtitle).show();

      $(elms.waitingEveryone).hide();
      $(elms.waitingEveryoneSubtitle).hide();
    } else {
      $(elms.everyoneReadyTitle).hide();
      $(elms.everyoneReadySubtitle).hide();

      $(elms.waitingEveryone).show();
      $(elms.waitingEveryoneSubtitle).show();
    }

    $(elms.startBtn).prop("disabled", !allReady);

    if (allReady && $("#page-waitingroom").hasClass("is-leader") && !alreadyStarted) {
      fb.update(fb.teamAttributesPath, {
        isStarting: true,
      });
    }
  };

  const updateAspirationProfile = function (players) {
    // update avatar and name on aspiration wall
    const $aspirationWall = $(elms.aspirationWall);

    players.forEach(function (player) {
      const hasMessage = $aspirationWall
        .children()
        .find(elms.aspirationPerson + `[data-user-id=${player.userId}]`);

      if (hasMessage.length > 0) {
        $.each(hasMessage, function (index, msg) {
          $(msg).find(".aspiration__avatar").attr("src", player.avatarURL);
          $(msg).find(".aspiration__name").text(player.name);
        });
      }
    });
  };

  const onPlayersStateChanged = (e, eData) => {
    /* Update players DOM */
    const players = eData?.data;
    updatePlayersOrKickMe(players);
    maybeReadyToStart(players);
    updateAspirationProfile(players);
  };

  bdjs.listen("bd__playersStateChanged", onPlayersStateChanged);

  // On Team Data Changed
  // ------------------------------------------------------------------------
  const maybeTeamNameChanged = (teamData) => {
    if ($(elms.pageWaitingRoom).hasClass("is-leader") || !teamData?.teamname)
      return;

    $(elms.teamName).val(teamData?.teamname);
  };

  const maybeTeamLeaderChanged = (teamData) => {
    const leaderId = teamData?.leader;

    if (!leaderId) return;

    const $elLeader = $(elms.playerItem.concat(`[player-id="${leaderId}"]`));
    const leaderText = $(elms.playerList).attr("data-leader-text");
    const htmlLeader = `<div class="gamePlayer__teamLeader">${leaderText}</div>`;

    $elLeader.find(".js-leader-text").html(htmlLeader);

    if (leaderId == CONFIG.user.id && !CONFIG.user_progress.is_leader) {
      CONFIG.user_progress.is_leader = true;
      $(elms.leaderPopup).addClass("is-open");
      $(elms.pageWaitingRoom).removeClass("is-member").addClass("is-leader");
      $(elms.teamName).removeAttr("readonly");
      $elLeader.find(elms.deletePlayerBtn).addClass("hidden");
    }
  };

  const maybeStartTheGame = (teamData) => {
    if (!teamData?.isStarting || alreadyStarted) return;
    autoStartGame();
  };

  const onTeamStateChanged = (e, eData) => {
    const teamData = eData?.data;

    maybeTeamNameChanged(teamData);
    maybeTeamLeaderChanged(teamData);
    maybeStartTheGame(teamData);
  };

  bdjs.listen("bd__teamAttributeChanged", onTeamStateChanged);

  // Setup Team state on first load
  // ------------------------------------------------------------------------
  const setTeamInitialState = (e, eData) => {
    const teamData = eData?.data;
    $(elms.teamName).val(teamData?.attributes?.teamname || "");
  };

  bdjs.listen("bd__teamInitialState", setTeamInitialState);

  // Copy team id
  // ------------------------------------------------------------------------
  const onCopyTeamId = () => {
    const teamID = String($(elms.teamIdValue).val());
    const isCopied = copyTextToClipboard(teamID);
    if (!isCopied) return false;

    $(elms.teamId).addClass("is-copied");
    setTimeout(() => $(elms.teamId).removeClass("is-copied"), 1000);
  };

  // set team name on input
  // ------------------------------------------------------------------------\

  let timeToWait = 2; //seconds

  /**
   * @type {ReturnType<typeof setInterval> | undefined}
   */
  let intervalUpdate = undefined;

  $(document).on("input", elms.teamName, function () {
    const value = $(this).val();

    clearInterval(intervalUpdate);
    timeToWait = 2;
    intervalUpdate = setInterval(() => {
      timeToWait--;

      if (timeToWait <= 0) {
        clearInterval(intervalUpdate);

        fb.update(fb.teamAttributesPath, {
          teamname: String(value).trim(),
        });
      }
    }, 1000);
  });

  // Kick player
  const onKickMember = async (e) => {
    e.preventDefault();

    const $btn = $(e.currentTarget);
    const isLoading = $btn.hasClass("is-loading");
    if (isLoading) return false;

    const $playerToDelete = $btn.parents(elms.playerItem);
    const memberID = $playerToDelete.attr("player-id");
    if ($btn.hasClass("is-loading")) return;

    $btn.addClass("is-loading");

    await bdjs.goAsync(
      bdapi.post("member/kick-member", { member_id: memberID }),
    );

    $btn.removeClass("is-loading");
  };

  // Onboarding Box
  // ------------------------------------------------------------------------
  // let isLoading = false;
  const onToggleReady = () => {
    fb.update(fb.currentPlayerPath, {
      ready: !isReady,
    });
  };

  // Start game (countdown skipped — timer attrs are set server-side in start-game)
  // ------------------------------------------------------------------------
  $(document).on("click", elms.startBtn, (e) => {
    e.preventDefault();
    autoStartGame();
  });

  // Leave Game
  // ------------------------------------------------------------------------
  const onLeaveTeam = async (e) => {
    e.preventDefault();

    if (isLoading) return false;
    const message = "Are you sure you want to leave the team?";
    const confirm_result = confirm(message);

    if (!confirm_result) {
      return false;
    }

    const $this = $(e.currentTarget);

    $this.addClass("is-loading");
    isLoading = true;
    isLeaving = true;

    await bdjs.goAsync(bdapi.post("member/leave-team"));
    window.location.reload();
    return false;
  };

  // Leader Popup
  // ------------------------------------------------------------------------

  const closeLeaderPopup = function (e) {
    e.preventDefault();
    const $this = $(this);
    $this.parents(elms.leaderPopup).removeClass("is-open");
  };

  $(elms.leaderPopup)
    .find(".js-completionPopup-close")
    .on("click", closeLeaderPopup);

  $(document).on("click", elms.teamIdCopy, onCopyTeamId);
  $(document).on("click", elms.deletePlayerBtn, onKickMember);
  $(document).on("click", elms.readyBtn, onToggleReady);
  $(document).on("click", elms.cancelBtn, onToggleReady);
  $(document).on("click", elms.gameInfoLeave, onLeaveTeam);
};
